<template>
  <div>
    <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol lg="3">
            <CInput
              label="Code"
              invalid-feedback="Code should be filled"
              required
              :disabled="isReadonly"
              v-model="$v.questionForm.code.$model"
              :is-valid="!$v.questionForm.code.$invalid"
            />
          </CCol>

          <CCol lg="3">
            <CInput
              label="Name"
              invalid-feedback="Name should be filled"
              required
              :disabled="isReadonly"
              v-model="$v.questionForm.name.$model"
              :is-valid="!$v.questionForm.name.$invalid"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="3">
              <div class="form-group">
                <label for="parent">Parent</label>
                <model-select
                  class="form-control"
                  id="parent"
                  :options="parentList"
                  v-model="$v.questionForm.parent.$model"
                  :isError="$v.questionForm.parent.$invalid"
                  placeholder="-- Sebagai Parent --"
                ></model-select>
                <div
                  v-if="$v.questionForm.parent.$invalid"
                  class="invalid-feedback-custom"
                >
                  Parent should be filled.
                </div>
              </div>
            </CCol>

          <CCol sm="3">
              <div class="form-group">
                <label for="end">End</label>
                <model-select
                  class="form-control"
                  id="end"
                  :options="endList"
                  v-model="$v.questionForm.end.$model"
                  :isError="$v.questionForm.end.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.questionForm.end.$invalid"
                  class="invalid-feedback-custom"
                >
                  End should be filled.
                </div>
              </div>
            </CCol>
        </CRow>

        <CRow>
          <CCol lg="9">
            <label for="message">Message</label>
            <quill-editor
              style="height: 200px; margin-bottom: 70px"
              :content="content"
              :options="editorOption"
              :disabled="isReadonly"
              v-model="$v.questionForm.messages.$model"
              @change="onEditorChange($event)"
            >
            </quill-editor>
            <div v-if="$v.questionForm.messages.$invalid" class="invalid-feedback-custom">
              message harus di isi.
            </div>
            <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.questionForm.description.$model"
                :is-valid="!$v.questionForm.description.$invalid"
              /> -->
          </CCol>
          
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.questionForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "Question",
  components: { GlobalTable, quillEditor },
  data() {
    return {
      title: "Question",
      fields: [
        { key: "code", label: "Code", sorter: true },
        { key: "name", label: "Name", sorter: true },
        // { key: "messages", label: "Message", sorter: true },
        { key: "parent", label: "Parent", sorter: true },
        { key: "end", label: "End", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      parentList: [],
      endList: [],
      questionForm: tableInterfaces.questions,
      isReadonly: false,
      isLoading: false,
      addButton: false,
      isEdit: false,
      endList: [
        { value: "1", text: "Yes" },
        { value: null, text: "No" },
      ],
      content: "",
      editorOption: {}, // data quill
    };
  },
  validations: {
    questionForm: {
      name: { required },
      messages: { required },
      code: {required},
      parent:{},
      end: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getQuestion();
      this.getparentList();
    },
    getQuestion: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/question/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isReadonly = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.isReadonly = null;
      this.resetForm();
    },
    getparentList: function(){
      this.axios.get("console/dropdown/parent").then((response) => {
        this.parentList = response.data.data;
      });
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.questionForm = item;
      if(item.show === '1') {
        this.isReadonly = true;
      } else {
        this.isReadonly = false;
      }
    },
    resetForm: function () {
      for (var i in tableInterfaces.questions) {
        tableInterfaces.questions[i] = null;
      }
      this.questionForm = tableInterfaces.questions;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/master/question/add", this.questionForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/question/update", this.questionForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.questionForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
